var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.11643 17.5998H14.8895C15.9054 17.5998 16.8306 17.0838 17.3652 16.2195C17.8995 15.3549 17.9474 14.2957 17.4931 13.3866L11.6063 1.60936C11.11 0.616423 10.1125 -0.000178968 9.00243 3.89652e-08C7.89312 3.89652e-08 6.89553 0.616781 6.3996 1.60936L0.512878 13.3866C0.058484 14.2957 0.106466 15.3549 0.64071 16.2195C1.17531 17.0838 2.10057 17.5998 3.11643 17.5998ZM1.82486 14.0422L7.71158 2.26499C7.96151 1.76512 8.44383 1.46667 9.00279 1.46667C9.56138 1.46649 10.0444 1.76494 10.2944 2.26499L16.1811 14.0422C16.4067 14.4935 16.383 15.0192 16.1177 15.4483C15.8484 15.8836 15.4008 16.1332 14.8895 16.1332H3.11643C2.6051 16.1332 2.15751 15.8836 1.88824 15.4483C1.6229 15.0192 1.59927 14.4935 1.82486 14.0422Z",
    fill: "#E57E25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99896 11.2277C9.40394 11.2277 9.73229 10.8993 9.73229 10.4944V4.67083C9.73229 4.26585 9.40394 3.9375 8.99896 3.9375C8.59398 3.9375 8.26562 4.26585 8.26562 4.67083V10.4944C8.26562 10.8993 8.59398 11.2277 8.99896 11.2277Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99896 14.9612C9.40394 14.9612 9.73229 14.6329 9.73229 14.2279V13.4052C9.73229 13.0002 9.40394 12.6719 8.99896 12.6719C8.59398 12.6719 8.26562 13.0002 8.26562 13.4052V14.2279C8.26562 14.6329 8.59398 14.9612 8.99896 14.9612Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.1cfb7d5dfc7d2852dae1d94ff68c12ba.svg";
export { ForwardRef as ReactComponent };